import { serverInst } from "./request";

export function sendCaptcha(phone) {
  return serverInst.post('/api/sendVerificationCode', {
    phone,
  })
}
export function registerAccount(data) {
  return serverInst.post('/api/register', data)
}